// extracted by mini-css-extract-plugin
export default {"btns":"modal-form_btns__xW+TB"};